module.exports = __webpack_public_path__ + "static/media/BNF-logo-filter.4c864bca.svg";